import { UserRole } from '../api/adminServices'

export const ALL_USER_ROLES: UserRole[] = [
  'SHIPPER_DISTRIBUTION_MANAGER',
  'SHIPPER_OBSERVER',
  'FREIGHTER_FOREMAN',
  'FREIGHTER_DRIVER',
  'SYSTEM_ADMIN',
  'SHIPMENT_RECEIVER',
  'TRAFFIC_OFFICER',
  'ROAD_SERVICE',
]
